import { deviceApi } from '../../api/deviceApi'
import { taskApi } from '../../api/taskApi'
import { utgApi } from "../../api/utgApi"

import { addNotification, NotificationTypes } from './notificationActions'

import { utgListFiltersValueSignal } from '../signals/userSettingsSignals.js'

import { utgSignal, utgLoadedSignal, utgErrorSignal, utgListSignal, utgListLoadedSignal, utgListErrorSignal, componentSignal, componentLoadedSignal, componentErrorSignal, utgTaskListSignal, utgTaskListErrorSignal, utgTaskListLoadedSignal, utgDeviceListSignal, utgDeviceListLoadedSignal, utgDeviceListErrorSignal } from "../signals/utgSignals"

import { getFilterByComponentId } from '../../utils/filters'

import { navigate } from '../../utils/navigator.js'
import { stringifyRecursive } from '../../utils/utils'

export const fetchUtgList = async (businessEntityId, filter, config, accessToken) => {
    //console.log(`Entered with BEID ${businessEntityId} and filter ${stringifyRecursive(filter)}`)
    utgListLoadedSignal.value = false
    utgListSignal.value = []
    return await utgApi.fetchUtgList(businessEntityId, filter, config, accessToken).then(
        (utgs) => {
            utgListSignal.value = utgs
            utgListLoadedSignal.value = true
            //console.log("Returning the following UTGs:")
            //console.log(utgs)
            return utgs
        }
    ).catch(
        (err) => {
            console.error(`fetchUtgListError: ${err.toString()}`)
            utgListErrorSignal.value = err.message
        }
    )
}

export const fetchUtg = async (businessEntityId, componentId, config, accessToken) => {
    utgLoadedSignal.value = false
    return await utgApi.fetchUtg(businessEntityId, componentId, config, accessToken).then(
        (utg) => {
            if (utg === null) {
                addNotification("The requested UTG does not exist for the current business entity", NotificationTypes.ERROR, true, "Error loading UTG")
                navigate(`/be/${businessEntityId}/utgs`)
                return null
            }
            //console.log("Inside fetchUtg: fetched the following")
            //console.log(utg)
            utgSignal.value = utg
            utgErrorSignal.value = null
            utgLoadedSignal.value = true
            return utgSignal.value
        }
    ).catch(
        (err) => {
            utgErrorSignal.value = err
            addNotification(`Unable to load data - ${err}`, NotificationTypes.ERROR, true, "Fetching UTG failed")
        }
    )
}

export const deleteUtg = async (businessEntityId, machinePermanentId, componentPermanentId, config, accessToken) => {
    utgListLoadedSignal.value = true
    return await utgApi.deleteUtg(businessEntityId, machinePermanentId, componentPermanentId, config, accessToken).then(
        async (response) => {
            const filter = utgListFiltersValueSignal.value
            return await fetchUtgList(businessEntityId, filter, config, accessToken).then(
                () => {
                    return response
                }
            )
        }
    ).catch(
        (error) => {
            utgListErrorSignal.value = error
            throw error
        }
    )
}
export const exportUtgList = async (businessEntityId, config, accessToken) => {
    return await utgApi.exportUtgList(businessEntityId, config, accessToken)
}

export const fetchComponent = async (businessEntityId, componentId, config, accessToken) => {
    componentLoadedSignal.value = false
    componentErrorSignal.value = null
    componentSignal.value = null
    return await utgApi.fetchComponent(businessEntityId, componentId, config, accessToken).then(
        (component) => {
            componentSignal.value = component
            componentLoadedSignal.value = true
            return componentSignal.value
        }
    ).catch(
        (err) => {
            componentErrorSignal.value = err
            addNotification(`Unable to load data - ${err}`)
        }
    )
}

export const updateComponent = async (businessEntityId, component, config, accessToken) => {
    componentLoadedSignal.value = false
    return await utgApi.updateComponent(businessEntityId, component, config, accessToken).then(
        (component) => {
            componentSignal.value = component
            componentLoadedSignal.value = true
            return component
        }
    ).catch(
        (error) => {
            componentErrorSignal.value = error
            throw error
        }
    )
}

export const fetchUtgTaskList = async (businessEntityId, componentId, config, accessToken) => {
    utgTaskListLoadedSignal.value = false
    utgTaskListErrorSignal.value = null
    utgTaskListSignal.value = []
    const filters = getFilterByComponentId(componentId)
    return await taskApi.fetchTaskList(businessEntityId, filters, config, accessToken).then(
        (utgTasks) => {
            utgTaskListSignal.value = utgTasks
            utgTaskListLoadedSignal.value = true
            return utgTaskListSignal.value
        }
    ).catch(
        (err) => {
            utgTaskListErrorSignal.value = err
            //console.log(err)
            addNotification(`Unable to load utg tasks data due to the following error - ${err}`)
        }
    )
}

export const fetchUtgDeviceList = async (businessEntityId, componentId, config, accessToken) => {
    utgDeviceListLoadedSignal.value = false
    utgDeviceListErrorSignal.value = null
    utgDeviceListSignal.value = []
    const filters = getFilterByComponentId(componentId)
    return await deviceApi.fetchDeviceList(businessEntityId, filters, config, accessToken).then(
        (devices) => {
            utgDeviceListSignal.value = devices
            utgDeviceListLoadedSignal.value = true
            return utgDeviceListSignal.value
        }
    ).catch(
        (err) => {
            utgDeviceListErrorSignal.value = err
            addNotification(`Unable to load utg devices data due to the following error - ${err}`)
        }
    )
}